import { Schedule } from '@lgg/isomorphic/types/__generated__/graphql';
import { TaskEvent } from './shared';

export const isEventOwner = (event: TaskEvent | Schedule, currentUserId: number) => {
  if (event.__typename === 'Task') {
    return event.assignedTo?.id === currentUserId;
  }

  return event.user?.id === currentUserId;
};
